import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Treatments from "@/components/Treatments";
import PriceList from "@/components/PriceList";
import Membership from "@/components/Membership";
import Testimonials from "@/components/Testimonials";
import Portfolio from "@/components/Portfolio";
import PaymentReturnHandler from "@/components/PaymentReturnHandler";
import Footer from "@/components/Footer";
import useReveal from "@/hooks/useReveal";

const BOOKING_URL = "https://sfaesthetics.book.app/";
const BOOKING_URL_SARAH = "https://sfaesthetics.book.app/";

export default function Home() {
  const rootRef = useReveal();

  const openBooking = (who = "stacy") => {
    const url = who === "sarah" ? BOOKING_URL_SARAH : BOOKING_URL;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div ref={rootRef} className="bg-[#F1EDDE] text-[#161618] min-h-screen">
      <Navigation onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />
        <About />
        <Treatments onBook={openBooking} />
        <PriceList />
        <Membership />
        <Testimonials />
        <Portfolio onBook={openBooking} />
      </main>
      <Footer />
      <PaymentReturnHandler />
    </div>
  );
}
